"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Months = void 0;
var Months;
(function (Months) {
    Months[Months["JAN"] = 1] = "JAN";
    Months[Months["FEB"] = 2] = "FEB";
    Months[Months["MAR"] = 3] = "MAR";
    Months[Months["APR"] = 4] = "APR";
    Months[Months["MAY"] = 5] = "MAY";
    Months[Months["JUN"] = 6] = "JUN";
    Months[Months["JUL"] = 7] = "JUL";
    Months[Months["AUG"] = 8] = "AUG";
    Months[Months["SEP"] = 9] = "SEP";
    Months[Months["OCT"] = 10] = "OCT";
    Months[Months["NOV"] = 11] = "NOV";
    Months[Months["DEC"] = 12] = "DEC";
})(Months = exports.Months || (exports.Months = {}));
exports.default = Months;
